import React from "react";
import { CommonModal } from "components/feature-specific/Modals/CommonModal";
import { css } from "@emotion/react";
import { Trans } from "react-i18next";
import { Watch } from "react-loader-spinner";
import { useHistory } from "hooks/useHistory";

interface VerificationStatusModalProps {
  show: boolean;
  state: "checking" | "active" | "failed" | "cancelled" | "error";
  message?: string;
  onClose: () => void;
}

export const SubscriptionVerificationModal: React.FC<VerificationStatusModalProps> = ({
  show,
  state,
  message,
  onClose,
}) => {
  const history = useHistory();
  const watchColor = "red";

  const getTitle = () => {
    switch (state) {
      case "checking":
        return "Verifying Payment";
      case "active":
        return "Payment Successful!";
      case "failed":
        return "Payment Failed";
      case "cancelled":
        return "Payment Cancelled";
      case "error":
        return "Verification Error";
      default:
        return "";
    }
  };

  const getBody = () => {
    if (message) return message;

    switch (state) {
      case "checking":
        return "We're verifying your payment. Please wait...";
      case "active":
        return "Thank you! Your payment was successful.";
      case "failed":
        return "Unfortunately, your payment failed.";
      case "cancelled":
        return "You cancelled the payment.";
      case "error":
        return "An error occurred while verifying your payment.";
      default:
        return "";
    }
  };

  const redirectToPlayTournament = () => {
    const tournamentId = localStorage.getItem("tournament-id");
    localStorage.removeItem("paymentReference");
    history.push(`/tournaments/${tournamentId}/play`);
    onClose();
  };

  return (
    <CommonModal
      style={css`
        .modal-content {
          width: 80%;
        }
        .modal-body-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          .modal-title {
            font-family: Poppins;
            font-size: 14px;
            font-weight: 700;
            line-height: 18px;
            letter-spacing: 1px;
            text-align: center;
          }
          img {
            width: 50%;
            height: auto;
          }
        }
        .footer-wrapper {
          display: flex;
          flex-direction: row;
          width: 100%;
          justify-content: space-around !important;
          align-items: center;
          /* width: 50% !important; */
          .btn {
            font-size: 14px;
            height: 34px !important;
            /* width: 50% !important; */
          }
        }
      `}
      show={show}
      hideCrossIcon={true}
      footer={
        <div className="flex gap-3 justify-center">
          {state !== "checking" && (
            <button
              onClick={() => {
                localStorage.removeItem("paymentReference");
                onClose();
              }}
              className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-1 rounded-md"
            >
              <Trans i18nKey="close">Close</Trans>
            </button>
          )}

          {state === "active" && localStorage.getItem("tournament-id") && (
            <button
              onClick={redirectToPlayTournament}
              className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-1 rounded-md"
            >
              <Trans i18nKey="play">Play</Trans>
            </button>
          )}

          {/* Uncomment if retry logic is needed
  {(state === "failed" || state === "error" || state === "cancelled") && onRetry && (
    <button onClick={onRetry} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1 rounded-md">
      Try Again
    </button>
  )} */}
        </div>
      }
    >
      <div className="modal-body-wrapper">
        <span className="modal-title">{getTitle()}</span>
        {state === "checking" && (
          <div>
            <Watch
              height="80"
              width="80"
              radius="48"
              color={watchColor}
              ariaLabel="watch-loading"
              wrapperStyle={{}}
              wrapperClass="justify-content-center"
              visible={true}
            />
          </div>
        )}
        <p className="text-sm text-gray-600 text-center">{getBody()}</p>
      </div>
    </CommonModal>
  );
};
